const meta = (title, extra = []) => ({
  pageTitle: title,
  breadcrumb: [{ text: 'Trader', active: false }, { text: 'Filo', active: extra.length === 0, to: extra.length ? { name: 'Fleet' } : undefined }, ...extra],
  resource: 'edges.manage',
  action: 'read',
})

export default [
  {
    path: '/admin/trader/fleet',
    name: 'Fleet',
    component: () => import('@/views/Admin/Trader/Fleet/Index.vue'),
    meta: meta('Filo'),
  },
  {
    path: '/admin/trader/fleet/create',
    name: 'FleetCreate',
    component: () => import('@/views/Admin/Trader/Fleet/Create.vue'),
    meta: meta('Akıllı Oluştur', [{ text: 'Akıllı Oluştur', active: true }]),
  },
  {
    path: '/admin/trader/fleet/:id',
    name: 'FleetDetail',
    component: () => import('@/views/Admin/Trader/Fleet/Detail.vue'),
    meta: meta('Filo Detayı', [{ text: 'Detay', active: true }]),
  },
]
